var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63333 9.05829C7.55 9.04996 7.45 9.04996 7.35833 9.05829C5.375 8.99163 3.8 7.36663 3.8 5.36663C3.8 3.32496 5.45 1.66663 7.5 1.66663C9.54167 1.66663 11.2 3.32496 11.2 5.36663C11.1917 7.36663 9.61667 8.99163 7.63333 9.05829Z",
    stroke: "#667689",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.675 3.33337C15.2917 3.33337 16.5917 4.64171 16.5917 6.25004C16.5917 7.82504 15.3417 9.10837 13.7833 9.16671C13.7167 9.15837 13.6417 9.15837 13.5667 9.16671",
    stroke: "#667689",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46667 12.1334C1.45 13.4834 1.45 15.6834 3.46667 17.025C5.75833 18.5584 9.51667 18.5584 11.8083 17.025C13.825 15.675 13.825 13.475 11.8083 12.1334C9.525 10.6084 5.76667 10.6084 3.46667 12.1334Z",
    stroke: "#667689",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2833 16.6666C15.8833 16.5416 16.45 16.3 16.9167 15.9416C18.2167 14.9666 18.2167 13.3583 16.9167 12.3833C16.4583 12.0333 15.9 11.8 15.3083 11.6666",
    stroke: "#667689",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsNormal);
export default __webpack_public_path__ + "static/media/Patients_Normal.aef20ec9010875f934a9825195350923.svg";
export { ForwardRef as ReactComponent };